/**
 * 
 *
 */

import FormControl from "../control";

class Textarea extends FormControl {
    init(element) {
        this.setRootElement(element);

        if (!!this.element) {
            this.type = 'textarea';
            this.validationType = 'textarea';

            this.maxlength = this.getControlElement().getAttribute('maxlength');
            this.count = this.getControlElement().value.length;
            this.setCounter();
            
            super.init();
        }
    }

    setRootElement(element) {
        this.element = element || document.querySelector('.js-textarea');
    }

    getCountElement() {
        return this.element.querySelector('[data-counter]');
    }

    onInputChange(event) {
        this.count = this.getControlElement().value.length;

        this.setCounter();

        if (this.count > this.maxlength) {
            this.setValidState('Please reduce the length of this content.');
        } else {
            this.setValidState('');

            super.onInputChange(event);
        }
    }

    onInputBlur(event) {
        if (this.count > this.maxlength) {
            this.setValidState('Please reduce the length of this content.');
        } else {
            super.onInputBlur(event);
        }
    }

    setCounter() {
        if (this.getCountElement() && !!this.maxlength) {
            this.getCountElement().textContent = `${this.count}/${this.maxlength}`;
        }
    }
}

// Textarea().init();
export default Textarea;